import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({});

export * from './resources/resource-api-slice';
export * from './users/users-api-slice';

export default reducer;
